import React, { useState, useRef, useEffect } from "react";
import { Send } from "lucide-react";
import { useOutletContext } from "react-router-dom";
import { ObjectId } from "bson";
import { chatbot } from "../../services/oprations/chatbotAPI";
import Message from "../../components/Dashboard/ChatBot/Message";
import TypingIndicator from "../../components/Dashboard/ChatBot/TypingIndicator";

const ChatbotInterface = () => {
  const { darkMode } = useOutletContext();

  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello! I'm your AI Doctor Assistant. How can I assist you today?",
      isUser: false,
      timestamp: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    },
  ]);


const [conversationId] = useState(() => new ObjectId().toHexString());


  const [inputMessage, setInputMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);






  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;

    const userMessage = {
      id: Date.now(),
      text: inputMessage,
      isUser: true,
      timestamp: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputMessage("");
    setIsTyping(true);

    try {
      const botResponse = await chatbot({
        conversation_id: conversationId,
        query: inputMessage,
      });

      const aiMessage = {
        id: Date.now() + 1,
        text: botResponse || "Sorry, I couldn't fetch a response at this time.",
        isUser: false,
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      console.error("Chatbot API error:", error);
      const fallbackMessage = {
        id: Date.now() + 2,
        text: "Sorry, something went wrong while fetching the response.",
        isUser: false,
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
      setMessages((prev) => [...prev, fallbackMessage]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div
      className={`h-full flex flex-col ${
        darkMode ? "bg-[#00254D]" : "bg-gray-50"
      }`}
    >
      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-6 space-y-4">
        {messages.map((message) => (
          <Message
            key={message.id}
            message={message.text}
            isUser={message.isUser}
            timestamp={message.timestamp}
            darkMode={darkMode}
          />
        ))}
        {isTyping && <TypingIndicator darkMode={darkMode} />}
        <div ref={messagesEndRef} />
      </div>

      {/* Chat Input */}
      <div
        className={`border-t p-3 ${
          darkMode ? "bg-[#00254D] border-gray-200" : "bg-white border-gray-200"
        }`}
      >
        <form onSubmit={handleSendMessage} className="flex gap-4">
          <input
            type="text"
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            placeholder="Ask about sessions, speakers, or event details..."
            className={`flex-1 px-4 py-3 border border-gray-300 rounded-2xl focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 ${
              darkMode ? "text-black" : "text-black"
            }`}
          />
          <button
            type="submit"
            disabled={!inputMessage.trim() || isTyping}
            className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-2xl hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:transform-none flex items-center gap-2"
          >
            <Send size={20} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatbotInterface;
